import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { EquipoService } from 'src/app/data-access/equipo.service';
import { UsuarioService } from 'src/app/data-access/usuario.service'
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-equipo',
  templateUrl: './equipo.component.html',
  styles: [
  ]
})
export class EquipoComponent implements OnInit {
  forma: FormGroup;
  model;
  p: number = 1;
  constructor(
    public fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private usuarioService: UsuarioService,
    private equipoService: EquipoService,
    private spinner: NgxSpinnerService,
    public modal: NgbModal
  ) {
    if(!this.usuarioService.adm()) this.router.navigate(['/menu']);
    this.iniciarForm();
  }

  ngOnInit(): void {
    this.addLista();
  }

  iniciarForm() {
    this.forma = this.fb.group({
      idEquipo: [0],
      nombre: ['', [Validators.required]],
      cantidad: [0, [Validators.required, Validators.min(1)]],
      estatus: [true, [Validators.required]]
    })
    this.model = this.forma;
  }
  
  Equipo;
  EquipoLista;
  addLista(){
    this.spinner.show();
    this.equipoService.getData().toPromise()
    .then(data => {
      this.spinner.hide();
      this.EquipoLista = data;
      //console.log(data);
    });
  }
  
  nuevo(content) {
    this.iniciarForm();
    //this.model.activo = 'S';
    this.modal.open(content,{size:'xl'});
  }

  oTmp;
  editar(content, modelo) {
    this.model = modelo;
    //this.modal.open(content,{size:'xl'});
    this.oTmp = { ...modelo }; 
    this.modal.open(content, { size: 'xl', beforeDismiss: () => {  
      var idx = this.EquipoLista.findIndex(x => x.idEquipo == this.oTmp.idEquipo); 
      this.EquipoLista[idx] = this.oTmp;       
      return true;  
    }});  
  }
  
  guardar() {
    //console.log(this.forma.value);
    if (this.forma.controls["idEquipo"].value == undefined) {
      this.equipoService.addData(this.forma.value).subscribe(
        (res) => {this.recargar();},
        (error) => {console.log(error);});
    }
    else {
      this.equipoService.updData(this.forma.controls["idEquipo"].value, this.forma.value).subscribe(
          (res) => {this.recargar();},
          (error) => {console.log(error);});
    }
    
  }
  
  recargar() {
    this.modal.dismissAll();
    this.addLista();
  }

  lfCantidad(){
    if(this.model.cantidad%2>0){
      this.model.cantidad = Math.ceil(this.model.cantidad);
    }
  }
}


